const WEB_CODE_VERSION = process.env.VUE_APP_VERSION; // web版本号

const BASE_GX_URL = process.env.VUE_APP_GX_BASE_URL;
const CDN_FILES_BASE_URL = process.env.VUE_CDN_FILES_BASE_URL; // cdn的地址路径
const GA_ID = process.env.VUE_GA_ID; // ga打点的id
const WEB_FONT_URL = process.env.VUE_APP_WEB_FONT_CDN_URL; // webfont

export {
  GA_ID,
  BASE_GX_URL,
  WEB_FONT_URL,
  WEB_CODE_VERSION,
  CDN_FILES_BASE_URL
};
